import { render, staticRenderFns } from "./Risk.vue?vue&type=template&id=0518c434&scoped=true"
import script from "./Risk.vue?vue&type=script&lang=js"
export * from "./Risk.vue?vue&type=script&lang=js"
import style0 from "./Risk.vue?vue&type=style&index=0&id=0518c434&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0518c434",
  null
  
)

export default component.exports